import customer from './customer.json';

export default { ...customer };
